import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const WalletIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="wallet" {...props} />;
};

export { WalletIcon };
